module.exports = __webpack_public_path__ + "static/media/RolePermissions.3c348c9a.png";